import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

export default {
    name: 'ModalAddEditLitterNotes',
    components: {
        DatePicker
    },
    directive: {},
    filters: {},
    mixins: [
        toastMessageMixins,
        dateMixins
    ],
    props: {},
    data() {
        return {
            isAPILoading: false,
            saveButtonText: 'Save',
            actionText: 'Add',
            cancelButtonText: 'Cancel',
            inputFields: {
                litterNote: '',
            },
            action: 'Add',
            noteId: null,
            matingId: null,
            prevNote: ''
        }
    },
    computed: {
        validationRules() {
            let fields = {
                inputFields: {
                    litterNote: {}
                }
            }

            fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true);

            return fields;
        },
    },
    watch: {},
    created() { },
    methods: {
        show(content) {
            this.clearFields();

            this.matingId = content.matingId

            if (content.action === "Edit") {
                this.saveButtonText = "Update"
                this.actionText = "Update"
                this.action = "Edit"
                this.inputFields.litterNote = content.content.notes
                this.prevNote = content.content.notes
                this.noteId = content.content.id
            }

            $(this.$refs.modalAddEditLitterNotes).modal('show');
        },
        clearFields() {
            this.inputFields.litterNote = ''
            this.saveButtonText = "Save"
            this.actionText = "Add"
            this.cancelButtonText = "Cancel"
            this.action = "Add"
            this.noteId = null
            this.$v.$reset();
        },
        async onSaveLitterNote() {
            const { ERROR_SAVE_NOTE, ERROR_UPDATE_NOTE, SUCCESS_SAVE_NOTE, SUCCESS_UPDATE_NOTE} = this.toastMessages.litterNotes();

            const isUpdate = this.action === "Edit"
            //Validate Fields
            const { litterNote } = this.$v.inputFields;
            litterNote.$touch();

            if (litterNote.$invalid) {
                return;
            }

            let requestBody = {
                matingId: this.matingId,
                note: this.inputFields.litterNote,
            };

            if (this.noteId && isUpdate) {
                requestBody.id = this.noteId
            }

            // Check if the note has not changed
            if (isUpdate && this.prevNote === this.inputFields.litterNote) {
                this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_NOTE);
                this.hideModal();
                return;
            }

            try {
                this.isAPILoading = true;
                const response = isUpdate
                    ? await breedingManagementService.updateLitterNotes(requestBody)
                    : await breedingManagementService.saveLitterNotes(requestBody);

                if (response.status === STATUS_CODES.SUCCESS_POST) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, isUpdate ? SUCCESS_UPDATE_NOTE : SUCCESS_SAVE_NOTE);
                    this.refreshTable();
                } else {
                    this.hideModal();
                    this.showAPIErrorToast(isUpdate ? ERROR_UPDATE_NOTE : ERROR_SAVE_NOTE, res);
                }

            } catch (err) {
                this.hideModal();
                this.showAPIErrorToast(ERROR_SAVE_NOTE, err);
            } finally {
                this.isAPILoading = false;
            }
        },
        onBlur(field) {
            const { litterNote } = this.$v.inputFields;
            litterNote.$touch();
        },
        hideModal() {
            this.clearFields()
            // Hide modal
            $(this.$refs.modalAddEditLitterNotes).modal('hide');
        },
        refreshTable() {
            this.hideModal();
            this.$emit('getTableContent');
        }
    },
    validations() {
        return this.validationRules;
    }
    // third party libraries
}